import {AccessType, LogLevel, LogResource, Role} from '@app/modules/shared/data/constants';
import {RemoteUserAdditionalInfoStateModel} from '@app/state/remote-users.state';
import {User} from '@app/models/vcr-entity/user';
import {LogService} from '@app/services/log.service';
import {UtilService} from '@app/modules/shared/services/util.service';

export class RemoteParticipantInfo {
  id: number;
  displayName: string;
  firstName: string;
  lastName: string;
  name: string;
  accessType: AccessType;
  role: Role;
  isGuest: boolean;
  personalColor: string;
  additionalInfo: RemoteUserAdditionalInfoStateModel;


  constructor(user: User, userInfo: RemoteUserAdditionalInfoStateModel) {
    this.id = user.id;
    this.displayName = UtilService.generateDisplayName(user);
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.name = user.name;
    this.accessType = user.accessType;
    this.role = user.role;
    this.personalColor = user.personalColor;
    this.isGuest = user.isGuest;
    this.additionalInfo = userInfo;
  }

  setAdditionalInfo(userInfo: RemoteUserAdditionalInfoStateModel) {
    LogService.writeLog(`Set remote participant - ${this.firstName} additional info`, LogLevel.DEBUG, LogResource.CORE);
    this.additionalInfo = userInfo;
  }

  isSupportOrTeacher(): boolean{
    return this.accessType === AccessType.TEACHER || this.accessType === AccessType.SUPPORT;
  }
}
